import React from 'react'

function Policy2025() {
  return (
    <div className='policy2025-conatiner'>
        <h1 className='policy2025-description'>Policy 2025 description</h1>
        <h1>Coming soon.....</h1>
      
    </div>
  )
}

export default Policy2025
